import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
const Tab1 = ({
  Item_Code,
  Item_UOM,
  PackingUnit,
  PriceList,
  Customer,
  Supplier,
  BatchNo,
  Currency,
  Rate,
  ValidFrom,
  ValidUpto,
  LeadTimeindays,
  Note,
  Reference,
}) => {

  console.log("123sa",Item_Code.Item_Code_list);
  
  return (
    <>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Details</p>
        </div>

        <div className="col-4">
          <div className={Item_Code.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={Item_Code.Item_Code_list}
              label="Item Code"
              getOptionLabel={(item) =>
                item.isNew ? "+ Create Item Code" : item.item_code
              }
              getOptionValue={(item) => item.item_code}
              createNewUrl="/master/item/create-item"
              createNewLabel="Create Item Code"
              value={Item_Code.select_Item_Code}
              onChange={(val) => Item_Code.setselect_Item_Code(val)}

            />



          </div>

        </div>
        <div className="col-4">
          <div className={Item_UOM.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={Item_UOM.Item_UOM_list}
              label="UOM"
              getOptionLabel={(item) =>
                item.isNew ? "+ Create New UOM" : item.name
              }
              getOptionValue={(item) => item.name}
              createNewUrl="/master/uom/create-uom"
              createNewLabel="Create New UOM"
              value={Item_UOM.select_Item_UOM}
              onChange={(val) => Item_UOM.setselect_Item_UOM(val)}
            />

          </div>
        </div>

        <div className="col-4">
          <div className="mb-3">
            <Input
              id="PackingUnit"
              label="Packing Unit"
              style={{
                height: "30px",
                border: PackingUnit.Error ? "1px solid red" : "",
              }}
              value={PackingUnit.PackingUnit}
              onChange={(e) => PackingUnit.setPackingUnit(e.target.value)}
            />
            <p
              style={{
                fontSize: "9px",
                color: "#00000099",
                marginLeft: "12px",
              }}
            >
              Quantity that must be bought or sold per UOM
            </p>
          </div>
        </div>
      </div>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Price List Details </p>
        </div>

        <div className="col-4">
          <div className={PriceList.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={[{ name: "Standard Buying" }, { name: "Standard Selling" }]}

              label="Price List"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={PriceList?.PriceList || ""}
              onChange={(value) => PriceList?.setPriceList?.(value)}
            />

          </div>
        </div>
        {PriceList?.PriceList === "Standard Selling" && (
          <div className="col-4">
            <div className="mb-3">
              <SelectSearch
                list={Customer.Customer_list}
                style={{
                  height: "30px",
                  border: Customer.Error ? "1px solid red" : "",
                }}
                label="Customer"
                getOptionLabel={(item) =>
                  item.isNew ? "+ Create New Customer" : item.name
                }
                getOptionValue={(item) => item.name}
                createNewUrl="/master/customer/create-customer"
                createNewLabel="Create New Customer"
                value={Customer.select_Customer}
                onChange={(val) => Customer.setselect_Customer(val)}
              />

            </div>
          </div>
        )}
        {PriceList?.PriceList === "Standard Buying" && (
          <div className="col-4">
            <div className="mb-3">
              <SelectSearch
                list={Supplier.Supplier_list}
                style={{
                  height: "30px",
                  border: Supplier.Error ? "1px solid red" : "",
                }}
                label="Supplier"
                getOptionLabel={(item) =>
                  item.isNew ? "+ Create New Supplier" : item.name
                }
                getOptionValue={(item) => item.name}
                createNewUrl="/master/supplier/create-supplier"
                createNewLabel="Create New Supplier"
                value={Supplier.select_Supplier}
                onChange={(val) => Supplier.setselect_Supplier(val)}
              />

            </div>
          </div>
        )}


        <div className="col-4">
          <div className="mb-3">
            <SelectSearch
              list={BatchNo.BatchNo_list}
              style={{
                height: "30px",
                border: BatchNo.Error ? "1px solid red" : "",
              }}
              label="Batch No"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={BatchNo.select_BatchNo}
              onChange={(val) => BatchNo.setselect_BatchNo(val)}
            />
          </div>
        </div>

        <div className="col-6">
          <div className="mb-3">
            <Input
              id="Currency"
              label="Currency"
              style={{
                height: "30px",
                border: Currency.Error ? "1px solid red" : "",
              }}
              value={Currency.Currency}
              onChange={(e) => Currency.setCurrency(e.target.value)}
              readOnly
            />
          </div>
        </div>
        <div className="col-6">
          <div className="mb-3">
            <Input
              id="Rate"
              label="Rate"
              style={{
                height: "30px",
                border: Rate.Error ? "1px solid red" : "",
              }}
              value={Rate.Rate}
              onChange={(e) => Rate.setRate(e.target.value)}
            />
          </div>
        </div>

        <div className="col-4">
          <div className="mb-3">
            <Input
              id="ValidFrom"
              type="date"
              label="Valid From"
              style={{
                height: "30px",
                border: ValidFrom.Error ? "1px solid red" : "",
              }}
              value={ValidFrom.ValidFrom}
              onChange={(e) => ValidFrom.setValidFrom(e.target.value)}
            />
          </div>
        </div>
        <div className="col-4">
          <div className="mb-3">
            <Input
              id="ValidUpto"
              type="date"
              label="Valid Upto"
              style={{
                height: "30px",
                border: ValidUpto.Error ? "1px solid red" : "",
              }}
              value={ValidUpto.ValidUpto}
              onChange={(e) => ValidUpto.setValidUpto(e.target.value)}
            />
          </div>
        </div>
        <div className="col-4">
          <div className="mb-3">
            <Input
              id="LeadTimeindays"
              label="Lead Time in days"
              style={{
                height: "30px",
                border: LeadTimeindays.Error ? "1px solid red" : "",
              }}
              value={LeadTimeindays.LeadTimeindays}
              onChange={(e) => LeadTimeindays.setLeadTimeindays(e.target.value)}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="mb-3">
            <Textarea
              id="Note"
              label="Note"
              style={{
                height: "30px",
                border: Note.Error ? "1px solid red" : "",
              }}
              value={Note.Note}
              onChange={(e) => Note.setNote(e.target.value)}
            />
          </div>
        </div>

        <div className="col-6">
          <div className="mb-3">
            <Input
              id="Reference"
              label="Reference"
              style={{
                height: "30px",
                border: Reference.Error ? "1px solid red" : "",
              }}
              value={Reference.Reference}
              onChange={(e) => Reference.setReference(e.target.value)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Tab1;
